// Floating hex particles for dark sections. Brand secondary color only.
const HEXES = [
  { left: "6%",  top: "12%", size: 40, delay: "0s"   },
  { left: "18%", top: "68%", size: 28, delay: "1.2s" },
  { left: "34%", top: "22%", size: 22, delay: "2.4s" },
  { left: "52%", top: "78%", size: 44, delay: "0.6s" },
  { left: "68%", top: "18%", size: 30, delay: "3.2s" },
  { left: "82%", top: "62%", size: 36, delay: "1.8s" },
  { left: "92%", top: "28%", size: 24, delay: "2.6s" },
];

const Hex = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2 L21 7 L21 17 L12 22 L3 17 L3 7 Z"
      stroke="currentColor"
      strokeWidth="1.4"
      fill="currentColor"
      fillOpacity="0.06"
    />
  </svg>
);

export default function HexParticles({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {HEXES.map((h, i) => (
        <div
          key={i}
          className="hex-particle"
          style={{ left: h.left, top: h.top, animationDelay: h.delay }}
        >
          <Hex size={h.size} />
        </div>
      ))}
    </div>
  );
}
